import { Component, Input } from '@angular/core';
import { CabHireLocationInput } from '@sabstravtech/obtservices/angular';

@Component({
  selector: 'app-taxi-location',
  templateUrl: './taxi-location.component.html',
  styleUrl: './taxi-location.component.scss',
  standalone: false
})
export class TaxiLocationComponent {
  @Input() location: CabHireLocationInput;
  @Input() isVia = false;
}
